module.exports = {
  Invalid20: 'Giá bán 20\' không được nhỏ hơn chi phí.',
  Invalid40: 'Giá bán 40\' không được nhỏ hơn chi phí.',
  Invalid45: 'Giá bán 45\' không được nhỏ hơn chi phí.',
  ALL: '【Tất cả】',
  ALLINIncludes: 'Giá ALL IN bao gồm các phụ phí sau:',
  ALLINRemarks: 'Lưu ý: Giá ALL IN đã bao gồm các khoản phí có nền màu xám trong phần phụ phí.',
  ALLRG: '【Tất cả】',
  AbnormalDetected: 'Thân mến, theo quy tắc kiểm tra của hệ thống, phát hiện giá cước chờ duyệt có thể có các vấn đề sau. Để biết chi tiết, vui lòng nhấp vào tiêu đề màu xanh.',
  Accept: 'Chấp nhận',
  AcceptTenant: 'Bên chấp nhận',
  AcceptTime: 'Ngày chấp nhận',
  AcceptUser: 'Người chấp nhận',
  Accepted: 'Đã chấp nhận',
  Add: 'Thêm mới',
  AddCondition: 'Thêm điều kiện kiểm tra',
  AddFee: 'Thêm phụ phí',
  AddNewCustomer: 'Thêm khách hàng mới',
  Address: 'Địa chỉ',
  Agent: 'Đại lý',
  Agree: 'Đồng ý yêu cầu',
  CancelAgree: 'Thu hồi đồng ý',
  Canceled: 'Đã thu hồi',
  Agreed: 'Đã đồng ý',
  Air: 'Vận chuyển hàng không',
  AirStatistics: 'Thống kê giá cước hàng không',
  Aircraft: 'Loại máy bay',
  AircraftFullName: 'Tên đầy đủ loại máy bay',
  Airliner: 'Máy bay chở khách',
  AlertEQAbnormal: 'Cảnh báo khi so sánh giá các loại container khác nhau trong cùng điều kiện xuất hiện các trường hợp sau',
  AlertPlaceAbnormal: 'Cảnh báo khi so sánh giá cùng loại container tại cùng POL và POD xuất hiện các trường hợp sau',
  AlertSumAbnormal: 'Cảnh báo khi tổng chi phí vận chuyển xuất hiện các trường hợp sau',
  AlertValidAbnormal: 'Cảnh báo khi thời hạn hiệu lực của giá cước xuất hiện các trường hợp sau',
  AllState: '【Tất cả】',
  AllowedTier: 'Cấp độ được phép xem là',
  Amount: 'Chi phí',
  Approve: 'Duyệt',
  ApproveAsync: 'Có chạy tác vụ duyệt ở chế độ nền không?',
  TariffRatingAtTheTimeOfMaintenance: 'Định nghĩa cấp độ giá cước',
  ApproveSet: 'Cài đặt duyệt',
  ApprovedBy: 'Người duyệt',
  ApprovedDate: 'Ngày duyệt',
  Attachment: 'Tệp đính kèm',
  Audit: 'Duyệt',
  AuthAccept: 'Chia sẻ từ người khác',
  AuthInvite: 'Chia sẻ cho người khác',
  AuthInvite2: 'Chia sẻ giá cước',
  AuthAccept2: 'Đăng ký giá cước',
  AuthorizedClient: 'Đơn vị ủy thác',
  BOTH_EMPTY: '(văn) ① Lầm lẫn; ② Giả dối. \n',
  Back: 'Quay lại',
  BadDays: 'Định dạng hành trình không chính xác!',
  BasicInfo: 'Thông tin cơ bản',
  ECommerceEta: 'Thời gian dự kiến đến bến (ETA) thương mại điện tử',
  ECommerceEtd: 'Thời gian dự kiến khởi hành (ETD) thương mại điện tử',
  BasicPort: 'Cảng cơ bản',
  BeginDate: 'Hiệu lực',
  BeginDateCol: 'Hiệu lực từ',
  Big: 'Tăng',
  BillType: 'Loại vận đơn',
  BookingAgent: 'Đại lý đặt chỗ',
  Both: 'Giá đồng nhất trả trước/trả sau',
  Branch: 'C.Nhánh',
  BusinessType: 'Loại hình nghiệp vụ',
  ByDate: 'Theo thời gian',
  ByPort: 'Theo cảng',
  ByState: 'Theo trạng thái',
  CANCEL: 'Hủy',
  CHARGES: '(văn) ① Lầm lẫn; ② Giả dối. \n',
  COD: 'Quốc gia/vùng lãnh thổ đích',
  CODPrompt: 'Vui lòng nhập quốc gia/vùng lãnh thổ dỡ hàng',
  CODAirPrompt: 'Vui lòng nhập quốc gia/vùng lãnh thổ đích',
  COL: 'Quốc gia/vùng lãnh thổ xuất phát',
  COLPrompt: 'Vui lòng nhập quốc gia/vùng lãnh thổ xuất phát',
  COMMON_ERROR: 'Dòng {0}, {1} không chính xác;<br/>',
  CONFIRM: 'Xác nhận',
  COST_VAT: 'Thuế suất chi phí',
  CabinNature: 'Tính chất chỗ',
  CabinState: 'Trạng thái chỗ',
  Cancel: 'Hủy',
  CargoAircraft: 'Máy bay chở hàng',
  Carrier: 'Hãng tàu',
  Carrier_Air: 'Hãng hàng không',
  CasePriceInvalid: 'Giá bán đơn vị không thể nhỏ hơn chi phí.',
  ChargeName: 'Tên phí',
  ChargeOfDeliveryPlace: 'Phí địa điểm giao hàng',
  ChargeOfReceiptPlace: 'Phí địa điểm nhận hàng',
  ChargeType: 'Loại phí',
  ChargeUnit: 'Đơn vị tính phí',
  ChargedWeight: 'Trọng lượng tính phí',
  Check: 'Kiểm tra',
  CheckApproveSet: 'Cài đặt thời gian chờ phê duyệt',
  CheckInterval: 'Khoảng thời gian luân phiên',
  ChineseName: 'Tên tiếng Trung',
  Chk: '[Hộp kiểm]',
  City: 'Thành phố',
  ClickMe: 'Nhấp để chuyển chế độ tra cứu.',
  ClickMeSimple: 'Bấm vào Switch Query Mode. Giá vận chuyển của phương thức truy vấn đơn giản Ngày hết hạn mặc định bắt đầu từ hôm nay, để truy vấn giá vận chuyển ngày hết hạn khác, hãy vào truy vấn nâng cao.',
  Client: 'Khách hàng',
  ClientExist: 'Tên khách hàng đã tồn tại trong hệ thống!',
  ClientIsEmpty: 'Đơn vị ủy thác không được để trống.',
  ClientName: 'Tên khách hàng',
  Close: 'Đóng',
  ClosingDay: 'Ngày đóng hàng',
  Code: 'Mã số',
  Collect: 'Trả sau (CIF)',
  Coloader: 'Đồng nghiệp',
  ColoaderMin: 'Đồng nghiệp (Tối thiểu)',
  ColoaderPrice: 'Giá đồng nghiệp',
  ColoaderRate: 'Đồng nghiệp (Tỷ lệ)',
  ColumnName: 'Tên cột',
  Commodity: 'Hàng hóa',
  Common: 'Hàng thường',
  CompareTime: 'Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc!',
  CompareValidate: 'Thời gian kết thúc hiệu lực phải lớn hơn thời gian bắt đầu!',
  FreeTimeType: 'Loại miễn phí container',
  PleaseInput: 'Vui lòng nhập giá trị {0}.',
  NeedFreeBox: 'Miễn phí container {0} ngày hỗn hợp',
  FreeTimeCalculatedSeparately: 'Miễn phí bãi {0} ngày, miễn phí container {1} ngày',
  Contact: 'Người liên hệ',
  ContinueApprove: 'Tiếp tục kiểm duyệt',
  ContractNo: 'Số hợp đồng',
  Copy: 'Sao chép',
  CopyPriceNo: 'Sao chép số đơn',
  CopyQuotation: 'Sao chép báo giá',
  CopySetting: 'Sao chép cấu hình',
  Cost: 'Chi phí',
  Cost20: 'Chi phí 20\'',
  Cost40: 'Chi phí 40\'',
  Cost45: 'Chi phí 45\'',
  CostHC: 'Chi phí 40\'HC',
  CostMin: 'Chi phí (Tối thiểu)',
  CostPrice: 'Giá thành',
  CostRate: 'Chi phí (Tỷ lệ)',
  Country: 'Quốc gia',
  CountryPrompt: 'Vui lòng nhập quốc gia/ khu vực xuất phát',
  CreatedBy: 'Người NL',
  CreatedDate: 'Ngày tạo',
  Currency: 'Loại tiền',
  CurrentPrice: 'Đã phát hành',
  CurrentPriceEditSucceed: 'Sửa đổi giá cước đã phát hành thành công, trạng thái tự động chuyển thành giá cước chờ duyệt, bạn cần phê duyệt lại.',
  CurrentTenant: 'Công ty chúng tôi',
  CustomConfig: 'Tùy chỉnh...',
  CustomerMin: 'Khách trực tiếp (Tối thiểu)',
  CustomerPrice: 'Giá khách trực tiếp',
  CustomerRate: 'Khách trực tiếp (Tỷ lệ)',
  CyCy: 'CY-CY',
  CyDoor: 'CY-DOOR',
  CyRamp: 'CY-RAMP',
  Dangerous: 'Hàng nguy hiểm',
  DangerousClass: 'Cấp độ hàng nguy hiểm',
  DataGridConfig: 'Tùy chỉnh cột hiển thị',
  Day: 'Ngày',
  Days: 'Hành trình',
  DaysColSea: 'Hành trình (ngày)',
  DaysUnitSea: 'Hành trình (ngày)',
  DaysValidate: 'Hành trình không được để trống.',
  DecodeMarkupFailed: 'Phân tích cấu hình kiểm tra giá cước thất bại!',
  DelFee: 'Xóa phụ phí này',
  DelRate: 'Xóa giá cước',
  Delete: 'Xóa',
  DeleteCfg: 'Xóa mục cấu hình này',
  DepartureDay: 'Lịch tàu',
  DepartureDay2: 'Lịch tàu 2',
  DepartureDayOfAir: 'Lịch bay',
  DepartureDayOfAir2: 'Lịch bay chặng thứ hai',
  CargoAircraft2: 'Máy bay chở hàng chặng thứ hai',
  AircraftOrFreighter: 'Máy bay chở khách/chở hàng',
  FreighterOrAircraft: 'Máy bay chở hàng/chở khách',
  AirlinerNB: 'Máy bay chở khách (NB)',
  DesCharge: 'Chi phí điểm đến',
  Dest: 'Cảng dỡ hàng',
  DestinationDock: 'Cầu cảng tại cảng đích',
  Detail: '【Chi tiết】',
  DetailOfFCL: 'Chi tiết giá cước FCL',
  DetailOfLCL: 'Chi tiết giá cước LCL',
  Details: 'Chi tiết',
  DifferentCarrier: 'Giá cước kiểm tra thuộc nhiều hãng tàu, có tiếp tục không?',
  DifferentCarrierAndRegion: 'Giá cước kiểm tra thuộc nhiều hãng tàu và {0}, có tiếp tục không?',
  DifferentCarrierAndRegions: 'Giá cước kiểm tra thuộc nhiều hãng tàu, khu vực xếp và dỡ hàng, có tiếp tục không?',
  DifferentPOD: 'Cảng dỡ hàng của giá đã chọn không hoàn toàn giống nhau, có tiếp tục không?',
  DifferentPOL: 'Cảng xếp hàng của giá đã chọn không hoàn toàn giống nhau, có tiếp tục không?',
  DifferentRegion: 'Giá cước kiểm tra thuộc nhiều {0}, có tiếp tục không?',
  Direct: 'Trực tiếp',
  DirectCustomer: 'Khách trực tiếp',
  Dock: 'Cầu cảng',
  Dockland: 'Khu cảng',
  DocumentCategory: 'Loại tài liệu',
  DocumentId: 'Số serial tài liệu nguồn nhập',
  DuplicateFees: 'Phụ phí {0} bị trùng lặp!',
  DuplicateShare: 'Bạn đã chia sẻ giá cước cho {0}, không cần lặp lại thao tác.',
  EMPTY_DATATABLE: 'Máy chủ không có dữ liệu liên quan đến {0}, vui lòng liên hệ với quản trị viên hệ thống; \n',
  EQAbnormal: 'So sánh giá các loại container khác nhau trong cùng điều kiện có bất thường;',
  EQMustDifferent: 'Loại container không được giống nhau',
  EQ_TYPE_SIZE: 'Hàng và kiểu hộp {1} được liệt kê là {0} không chính xác; \n',
  EXISTS_SAME_TIME: 'Không thể nhập cùng một lúc; \n',
  EXISTS_SAME_TIME2: '{0} và {1} không thể nhập đồng thời.',
  Edit: 'Chỉnh sửa',
  EffectiveDate: 'Ngày hiệu lực',
  EffectiveDateType: 'Loại ngày hiệu lực',
  Email: 'Email',
  EndDate: 'đến',
  EndDateAlign: 'phải',
  EndDateCol: 'ngày hết hạn',
  EndTime: 'thời gian kết thúc',
  EnglishName: 'tên tiếng Anh',
  EqSize: 'loại container',
  EqType: 'chủng loại container',
  Error: 'lỗi',
  ErrorCfg: 'Cấu hình có lỗi, vui lòng kiểm tra.',
  ErrorRaised: 'Lỗi phát sinh.',
  ExceedMaxAmount: 'Khi chương trình không chạy kiểm tra ở chế độ nền, tối đa chỉ kiểm tra 300 dữ liệu mỗi lần.',
  ExistLoop: 'Tồn tại cài đặt vòng lặp',
  ExpirationDate: 'ngày hết hiệu lực',
  ExpirationDateType: 'loại ngày hết hiệu lực',
  Export: 'Xuất Excel',
  ExportByTemplate: 'Xuất theo mẫu',
  ExportMode: 'Vui lòng chọn phương thức xuất dữ liệu giá cước',
  ExportPDF: 'Xuất PDF',
  ExtraInfo: 'thông tin bổ sung',
  ExtraLoadFailed: 'Tải thông tin bổ sung thất bại!',
  FCL: 'container đầy (FCL)',
  FCLStatistics: 'Thống kê giá cước FCL',
  FIELD_TOO_LONG: '{0} hàng, {1} quá dài và độ dài tối đa cho phép là {2}; \n',
  FORMAT_NOT_MATCHING: '(văn) ① Lầm lẫn; ② Giả dối. \n',
  Fair: 'giữ nguyên',
  Fall: 'giảm',
  FaultCode: 'Mã lỗi:',
  FaultMessage: 'Thông tin:',
  Fax: 'fax',
  FeeFclPrompt: 'Vui lòng nhập tên viết tắt chi phí',
  FeeIndex: 'số thứ tự',
  FeeMin: 'Chi phí (Min)',
  FeeName: 'tên chi phí',
  FeeNameIsNull: 'Vui lòng nhập tên chi phí.',
  FeeRate: 'Chi phí (Rate)',
  FeeUnit: 'đơn vị tính phí',
  FeeUnitIsNull: 'Vui lòng nhập đơn vị tính phí.',
  Fees: 'chi phí',
  FileHistory: 'lịch sử tệp',
  FileName: 'tên tài liệu',
  FileSize: 'kích thước tài liệu',
  Find: 'tìm kiếm',
  Finished: 'Thao tác hoàn tất.',
  Flight: 'hạng mục dịch vụ',
  FreeTime: 'thời gian miễn phí container',
  FreightTerm: 'điều khoản vận chuyển',
  Fri: 'thứ Sáu',
  Friday: 'thứ Sáu',
  GenerateCharge: 'Tạo chi phí khi đặt chỗ',
  Goods: 'tên hàng hóa',
  GoodsLevel: 'Cấp độ',
  GreaterThanZero: 'Giá trị phải lớn hơn 0!',
  GroupNo: 'Mã nhóm thuộc về',
  HCInvalid: 'Giá bán 40\'HC không được thấp hơn chi phí.',
  HasApproved: 'Đã được kiểm duyệt.',
  HasDeleted: 'Đã xóa.',
  Hazard: 'Hàng nguy hiểm',
  HeadLiftAircraft: 'Chuyến bay khách đầu tiên',
  HiddenCost: 'Không được xem chi phí của chi nhánh khác.',
  Hour: 'Giờ',
  Hours: 'Tiếng',
  IS_EMPTY: 'Không thể để trống; \n',
  EXIST_THE_SAME_TIME: 'Số lượng các dòng {1} và {2} khác nhau; \n',
  IS_LESS: '{0} hàng, {1} không thể nhỏ hơn {2}; \n',
  IS_SAME: '{0} hàng {1} không thể giống như {2} hàng; \n',
  IWantShare: 'Tôi muốn chia sẻ giá cước cho',
  Import: 'Nhập từ Excel',
  GeekYumImport: 'Nhập giá cước từ Jiyu',
  OneStackImport: 'Nhập giá cước từ Yituo',
  InactiveRate: 'Giá có gạch ngang trên số đơn đã hết hiệu lực!',
  InputValue: 'Vui lòng nhập!',
  Invalid: 'Hết hiệu lực',
  InvalidSelection: 'Đặt dữ liệu đã chọn thành trạng thái vô hiệu?',
  InviteTenant: 'Bên mời',
  InviteUser: 'Người mời',
  IsActive: 'Có kích hoạt không',
  IsAllowedOperate: 'Bạn không có quyền kiểm duyệt hoặc xóa giá cước với cảng đi {0}, cảng đến {1}!',
  IsAllowedOperate_DiffBranch: 'Bạn không thể sửa giá cước do chi nhánh khác nhập!',
  IsApproveRecord: 'Có kiểm duyệt dữ liệu đã chọn không?',
  IsApproveRecords: 'Có kiểm duyệt dữ liệu đã chọn không?',
  IsBooked: 'Có tạo đơn hàng không',
  IsCopy: 'Bạn có muốn sao chép báo giá đã chọn không?',
  IsDeleteRecord: 'Có xóa dữ liệu đã chọn không?',
  IsDeleteRecords: 'Có xóa dữ liệu đã chọn không?',
  IsMarkup: 'Bạn chắc chắn muốn tăng giá?',
  KPIEmail: 'Người nhận báo cáo đánh giá KPI',
  LCL: 'Hàng ghép',
  Lane: 'Mã tuyến đường',
  LatestTemplateVersion: 'Phiên bản mẫu mới nhất là {0}',
  Level: 'Cấp độ',
  LoadSucceed: 'Nhập hệ thống thành công! \n',
  LocalCharge: 'Chi phí địa phương',
  MUST_EMPTY: '(văn) ① Lầm lẫn; ② Giả dối. \n',
  ManualAudit: 'Kiểm duyệt tăng giá thủ công',
  ECommerceFareOfflineReminder: 'Nhắc nhở ngừng áp dụng giá cước TMĐT đã công bố',
  ECommerceFareOfflineReminderContent: 'Khi giá cước TMĐT của hãng tàu liên quan được phê duyệt, giá cước TMĐT đã công bố trước đó sẽ ngừng áp dụng. Giá cước TMĐT được phê duyệt trong đợt này sẽ là giá cước TMĐT duy nhất của cùng hãng tàu được công bố.',
  PleaseSelectDataForTheSameTariffType: 'Vui lòng chọn dữ liệu cùng loại giá cước',
  MarketPrice: 'Giá thị trường',
  Markup: 'Tăng giá',
  MarkupBy: 'Tăng giá theo biên độ',
  MarkupRate: 'Phí cộng đồng bộ',
  MarkupTo: 'Cộng thêm đến',
  MarkupType: 'Loại phí cộng thêm',
  MaxMailPerDay: 'Tối đa thông báo email mỗi ngày',
  MaxQueryCount: 'Chỉ hiển thị một phần dữ liệu, vui lòng thêm điều kiện lọc!',
  MaxQueryCount2: 'Chỉ thu thập {0} dữ liệu đầu tiên, nhấn \'Xem\' để kết thúc hoặc \'Thêm\' để tiếp tục. Tối đa 10000 bản ghi, hãy thu hẹp phạm vi tìm kiếm.',
  Measurement: 'Kích thước',
  MinCharge: 'TỐI THIỂU',
  MinimumInvalidLCL: 'Giá tối thiểu không được lớn hơn giá theo trọng lượng/thể tích',
  MinimumPrice: 'Giá tối thiểu',
  ModifiedBy: 'Người chỉnh sửa',
  ModifiedDate: 'Ngày chỉnh sửa',
  Mon: 'Thứ Hai',
  Monday: 'Thứ Hai',
  Month: 'Tháng',
  MoreSetting: 'Cài đặt nâng cao',
  MustDifferent: '{0} và {1} không được giống nhau!',
  NA: 'Không áp dụng',
  NOT_ALLOWED_NEGATIVE: 'không được nhỏ hơn 0; \n',
  NOT_ALLOWED_UPLOAD: 'Không cho phép tải lên giá vận chuyển {0}; \n',
  NO_CONFIGURATION_CHARGES: 'Không có phụ phí cấu hình {0} cho máy chủ, vui lòng liên hệ với quản trị viên hệ thống; \n',
  NO_FIELD: 'Thiếu {0} trong bảng; \n',
  NO_OF: '{0} hàng, bảng thiếu OF với kiểu hộp {1}; n',
  NO_SUM: '{0} hàng, SUM với kiểu hộp {1} là bắt buộc; \n',
  NStep: 'Cấp N',
  NaCode: 'NAC',
  NeedCheckApproveCfg: '0: hệ thống không kiểm tra giá cước mới chưa duyệt; 1: hệ thống tự động kiểm tra',
  NeedCheckValidityCfg: '0: không kiểm tra hiệu lực trước khi duyệt; 1: kiểm tra hiệu lực trước khi duyệt',
  NeedMarkupCfg: '0: không phân tầng sau duyệt; 1: tạo giá cước đa tầng sau duyệt',
  NetConnectionFailed: 'Hệ thống không kết nối được máy chủ, gửi yêu cầu thất bại',
  NewRate: 'Thêm giá cước mới',
  Next: 'Tiếp theo',
  No: 'Không',
  NoChargeAndPrice: 'Vui lòng nhập thông tin giá hoặc phí',
  NoExchangeRate: 'Hệ thống chưa cập nhật tỷ giá {0}',
  NoHit: 'Không tìm thấy kết quả phù hợp!',
  NoLabel: 'Thêm',
  NoPODCharge: 'Không có thông tin phí cảng đến!',
  NoRecord: 'Không có dữ liệu.',
  TariffTableExportLevelTitleTips: 'Thông báo xuất bảng giá cước',
  TariffTableExportLevelTips: 'Đang xuất giá cước [Cấp giá: {0}]',
  PleaseSelectTheExpirationDateFirst: 'Vui lòng chọn thời hạn hiệu lực trước',
  EitherETDOrValidityPeriodMustBeFilledIn: 'ETD hoặc ngày hiệu lực phải nhập ít nhất một',
  theSelectedValidityPeriodCannotExceed3Months: 'Thời gian hiệu lực chọn không quá 3 tháng',
  theSelectedETDCannotExceed3Months: 'Khoảng thời gian ETD chọn không quá 3 tháng',
  NoRecordSelect: 'Chưa chọn dữ liệu!',
  NoRecordUpload: 'Không tìm thấy giá cước nào để tải lên!',
  NoSetting: 'Vui lòng thêm cấu hình PFMarkupSetting trong trang cài đặt',
  NoSettingSelect: 'Vui lòng đánh dấu mục cấu hình!',
  NoSurcharge: 'Không tìm thấy phí {0}',
  NoTax: 'Tất cả giá chưa bao gồm thuế, mức thuế cụ thể sẽ được tính theo quy định cuối cùng của người vận chuyển.',
  NoTierChange: 'Cấp độ giá cước không có thay đổi.',
  NotAccepted: 'Chờ chấp nhận',
  NotAllowed: 'Bạn không có quyền truy cập mức giá cước này.',
  NotAllowedCopy: 'Bạn không được phép sao chép báo giá của người khác.',
  NotAllowedDelete: 'Bạn không thể xóa giá cước do người dùng khác nhập!',
  NotAllowedDifferentCarrierAndRegion: 'Giá cước bao gồm nhiều hãng tàu và {0}, không được phép duyệt!',
  NotAllowedDifferentCarrierAndRegions: 'Giá cước bao gồm nhiều hãng tàu, khu vực xuất phát và dỡ hàng, không được phép duyệt!',
  NotAllowedDifferentRegions: 'Giá cước bao gồm nhiều {0}, không được phép duyệt!',
  NotAllowedFromCountry: 'Bạn không thể xem giá cước của cảng xuất phát tại quốc gia này!',
  NotAllowedFromRegion: 'Bạn không thể xem giá cước của cảng xuất phát tại khu vực này!',
  NotAllowedInput: 'Bạn không có quyền thêm cảng xuất phát này.',
  NotAllowedPOD: 'Bạn không thể xem giá cước của cảng đích này!',
  NotAllowedPOL: 'Bạn không thể xem giá cước của cảng xuất phát này!',
  NotAllowedPOD2: 'Bạn không thể xem giá cước của cảng đích ({0})!',
  NotAllowedPOL2: 'Bạn không thể xem giá cước của cảng xuất phát ({0})!',
  NotAllowedToCountry: 'Bạn không thể xem giá cước của cảng đích tại quốc gia này!',
  NotAllowedToRegion: 'Bạn không thể xem giá cước của cảng đích tại khu vực này!',
  NotAuth: 'Bạn không đủ quyền hạn.',
  NotCheck: 'Chờ duyệt',
  NotQuotationToOthers: 'Vui lòng không báo giá cho khách hàng của nhân viên kinh doanh khác.',
  NotRequired: 'Không thiết lập',
  NotSameLength: '{0} và {1} có số lượng khác nhau.',
  NotSave: 'Thao tác của bạn chưa được lưu, bạn có muốn lưu thay đổi không?',
  Num: 'Số lượng',
  Num20: 'Số lượng 20\'',
  Num40: 'Số lượng 40\'',
  Num45: 'Số lượng 45\'',
  NumHC: 'Số lượng 40\'HC',
  OK: 'Xác nhận',
  Origin: 'Cảng xuất phát',
  OtherInfo: 'Thông tin khác',
  FreeContainerPeriod: 'Thời gian miễn phí container',
  OvertimeApprove: 'Nhắc nhở quá hạn',
  Owner: 'Nhân viên kinh doanh phụ trách',
  POD: 'Cảng đích',
  PODCharge: 'Phí cảng đích',
  PODCity: 'Thành phố đích',
  PODCityPrompt: 'Vui lòng nhập thành phố đích',
  PODCodeChanged: 'Mã cảng dỡ hàng không khớp với dữ liệu hệ thống, giá cước này có thể đã hết hiệu lực!',
  PODCountry: 'Quốc gia (khu vực) cảng đích',
  PODIsNull: 'Vui lòng nhập cảng dỡ hàng!',
  PODPrompt: 'Vui lòng nhập cảng dỡ hàng',
  PODs: 'Nhiều cảng đích',
  POL: 'Cảng xuất phát',
  POLCity: 'Thành phố xuất phát',
  POLCityPrompt: 'Vui lòng nhập thành phố xuất phát',
  POLIsNull: 'Vui lòng nhập cảng xuất phát!',
  POLPrompt: 'Vui lòng nhập cảng xuất phát',
  PODPrompt2: 'Vui lòng nhập cảng đích',
  POLs: 'Nhiều cảng xếp hàng',
  PasteQuotation: 'Dán báo giá',
  PasteSetting: 'Cấu hình dán',
  PaymentTerm: 'Điều khoản thanh toán',
  PendingPrice: 'Chờ phê duyệt',
  Phone: 'Điện thoại',
  PlaceAbnormal: 'So sánh giá cùng POL, POD cùng loại container có bất thường;',
  PlaceOfDelivery: 'Địa điểm giao hàng',
  PlaceOfReceipt: 'Địa điểm nhận hàng',
  PleaseSelectBookingAgent: 'Vui lòng chọn đại lý',
  PlsChangeSystemCfg: 'Vui lòng chỉnh sửa cấu hình mặc định tại trang cấu hình hệ thống và kích hoạt các thiết lập cần thiết.',
  PlsConfigDetail: 'Vui lòng thiết lập chi tiết điều kiện đăng ký!',
  PlsInput: 'Vui lòng nhập {0}.',
  PlsInputClient: 'Vui lòng nhập thông tin khách hàng.',
  PlsInputCode: 'Vui lòng nhập tên đầy đủ hoặc mã số công ty của bên nhận!',
  PlsInputPOLPOD: 'Vui lòng nhập cảng xếp và cảng dỡ tại trang \'Thông tin cơ bản\'!',
  PlsInputPersonalInfo: 'Thông tin liên hệ và số điện thoại của khách hàng không được để trống!',
  PlsInputQuotationNo: 'Vui lòng nhập số báo giá',
  PlsInputRemark: 'Nhập thông tin ghi chú',
  PlsInputUserInfo: 'Vui lòng điền đầy đủ thông tin cá nhân.',
  PlsSelect: 'Vui lòng chọn',
  PlsSelectOF: 'Vui lòng chọn một thông tin giá cước làm cước biển.',
  PlsSelectOffice: 'Vui lòng chọn (chi nhánh) công ty bạn muốn đăng ký:',
  PlsSelectRecord: 'Vui lòng chọn bản ghi!',
  PlsSelectRejectEQ: 'Vui lòng chọn loại container từ chối',
  PlsSelectRule: 'Vui lòng chọn một quy tắc phụ phí!',
  PlsSelectTenant: 'Vui lòng chọn đối tác bạn muốn đăng ký:',
  PlsSelectValue: 'Vui lòng chọn!',
  PlsSetEmail: 'Thiết lập email nhận thông tin đăng ký:',
  PlsSubscribe: 'Vui lòng đăng ký thông tin bạn quan tâm, khi giá cước cập nhật bạn sẽ nhận được email thông báo.',
  PodRegion: 'Khu vực cảng đích',
  Port: 'Cảng',
  PortPrompt: 'Vui lòng nhập cảng',
  Prepaid: 'Trả trước',
  PriceDateType: 'Chuẩn hiệu lực',
  volumeWeightRatio: 'Tỷ lệ thể tích/trọng lượng',
  minRateValue: 'Đơn vị tính phí tối thiểu',
  PleaseNumber: 'Vui lòng điền số',
  F: 'Hiệu lực tính từ khi hàng lên xà lan',
  M: 'Hiệu lực tính từ khi hàng lên tàu mẹ',
  PriceInfo: 'Thông tin giá cước',
  PriceLoadFailed: 'Không thể tải giá cước bình thường!',
  PriceNo: 'Số giá cước',
  PriceNoIsNull: 'Vui lòng nhập số đơn giá cước!',
  PriceNoPrompt: 'Vui lòng nhập số đơn giá cước hoặc 7 số cuối',
  PriceSetting: 'Cấu hình giá cước',
  PriceState: 'Trạng thái giá cước',
  PriceState_Common: 'Bình thường',
  PriceState_Inquiry: 'Hỏi giá',
  PriceState_Lack: 'Căng thẳng',
  PriceState_Overbooked: 'Khoang đầy',
  PriceState_Reject: 'Không nhận',
  PriceState_Suspend: 'Ngừng bay',
  PriceTrend: 'Xu hướng giá',
  Print: 'In',
  Query: 'Truy vấn',
  QueryRecords: 'Đã truy vấn được {0} bản ghi.',
  Quotation: 'Báo giá',
  QuotationClient: 'Khách hàng tạm thời',
  QuotationDate: 'Thời gian báo giá',
  QuotationNo: 'Số báo giá',
  QuotationValidFrom: 'Hiệu lực báo giá',
  RATE_TYPE_ERROR: '{0} dòng, {1} không chính xác, tệp Excel được tải lên khác với loại vận chuyển trang hiện tại hoặc giá vận chuyển Excel được tải lên hiện tại không phải là mẫu mới nhất; \n',
  REGION_NO_POD: '{0} hàng, khu vực mà POD thuộc về {1} không phù hợp với khu vực dỡ hàng (ROD) trong bảng; \n',
  REGION_NO_POL: '{0} hàng, POL thuộc về khu vực {1} không khớp với khu vực khởi hành (ROL) trong bảng; \n',
  ROD: 'Khu vực đích',
  ROD_EQ: 'Khu vực dỡ hàng hoặc loại container',
  ROL: 'Khu vực xếp hàng',
  Rate: 'Tỷ lệ phí',
  RateByCost: 'Tỷ lệ chi phí',
  RateDetails: 'Chi tiết cước phí',
  RateGrade: 'Cấp độ giá cước',
  RateValidation: 'Xác thực hiệu lực giá cước',
  ReallyWantAccept: 'Bạn chắc chắn chấp nhận giá cước do {0} chia sẻ?',
  ReallyWantAgree: 'Bạn chắc chắn đồng ý giá cước do {0} yêu cầu?',
  ReallyWantCancelAccept: 'Bạn thực sự muốn hủy xem giá cước do {0} chia sẻ?',
  ReallyWantCancelShare: 'Bạn thực sự muốn ngừng chia sẻ giá cước cho {0}?',
  ReallyWantChange: 'Bạn chắc chắn điều chỉnh cấp độ giá cước thành {0}?',
  ReallyWantRefuse: 'Bạn chắc chắn từ chối giá cước do {0} yêu cầu?',
  ReallyWantShare: 'Bạn chắc chắn chia sẻ giá cước cho {0}?',
  ReceivingInstructions: 'Hướng dẫn đặc biệt nhận hàng',
  ReceivingType: 'Loại hướng dẫn đặc biệt nhận hàng',
  Records: 'Bảng {0} có {1} bản ghi,',
  Refresh: 'Làm mới',
  RefreshFinished: 'Đã làm mới xong',
  Refuse: 'Từ chối yêu cầu',
  RefuseRemark: 'Lý do từ chối',
  Refused: 'Đã từ chối',
  Region: 'Khu vực',
  RegionOrCarrier: 'Khu vực hoặc hãng tàu',
  RejectRate: 'Giá có gạch ngang đang ở trạng thái từ chối, xin cân nhắc!',
  RemarkAreaToolTip: 'Nhấn đúp để phóng to, nhấn đúp lần nữa để thu nhỏ.',
  Remarks: 'Ghi chú',
  ECommerceRemarks: 'Ghi chú giá thương mại điện tử',
  TraditionalRemarks: 'Ghi chú giá offline',
  RemoteBooking: 'Tạo mới ủy thác',
  Reset: 'Đặt lại',
  Rise: 'Tăng lên',
  Route: 'Khu vực',
  RouteAndPODEmpty: 'Tuyến đường và cảng dỡ hàng không được để trống đồng thời!',
  RouteAndPODEmpty1: 'Vui lòng đảm bảo ít nhất điền 1 trong các mục: cảng đi, cảng đến, tuyến đường, hãng tàu (hãng hàng không), đại lý đặt chỗ (nguồn giá cước).',
  RouteAndPODEmpty2: 'Vui lòng đảm bảo ít nhất điền 1 trong các mục: cảng đi, cảng đến, tuyến đường.',
  SELL_VAT: 'Thuế suất giá bán',
  SUM_NOT_EQUAL: 'Tổng chi phí của loại hộp {1} không bằng tổng số phụ phí; \n',
  SaleState: 'Trạng thái giá đặc biệt',
  Sales: 'Bán hàng',
  Sat: 'Thứ Bảy',
  Saturday: 'Thứ Bảy',
  Save: 'Lưu',
  SaveQuotation: 'Vui lòng lưu báo giá trước!',
  SavedSucceed: 'Đã lưu.',
  ApplyAgree: 'Phê duyệt đồng ý có hiệu lực',
  ApplyRefuse: 'Phê duyệt từ chối có hiệu lực',
  CancelAgreed: 'Thu hồi đồng ý có hiệu lực',
  ScheduleDetails: 'Lịch tàu',
  ScheduleInfo: 'Thông tin lịch tàu',
  SchemeAudit: 'Phê duyệt tăng giá phương án',
  Search: 'Tìm kiếm:',
  SelectRoute: 'Vui lòng chọn khu vực!',
  SelectTerm: 'Vui lòng chọn điều khoản thanh toán!',
  SelectTransportMode: 'Vui lòng chọn phương thức vận chuyển!',
  Self: 'Tự kinh doanh',
  Sell: 'Giá bán',
  ServiceCode: 'Mã dịch vụ',
  ServiceMode: 'Chế độ dịch vụ',
  Setting: 'Cài đặt',
  SettingDuplicate: 'Cài đặt trùng lặp',
  SettingNoEQ: 'Các dòng được chọn thiếu loại container!',
  SettingNoRegion: 'Các dòng được chọn thiếu {0}!',
  SettingOverlap: 'Hai cấu hình được chọn bị trùng lặp!',
  Share: 'Chung chuyến',
  ShareCarriers: 'Hãng tàu chung chuyến',
  ShareRemark: 'Hướng dẫn chia sẻ',
  ShareRemarks: '※Hướng dẫn chia sẻ hiển thị cho cả hai bên',
  ShareState: 'Trạng thái',
  ShareToPrompt: 'Vui lòng nhập bên nhận giá cước bạn chia sẻ!',
  ShareWithMyself: 'Bạn không cần chia sẻ giá cước cho công ty mình!',
  ShippingClause: 'Điều khoản vận chuyển',
  ShippingLine: 'Mã cảng ngoài',
  ShippingSchedule: 'Lịch tàu',
  Small: 'Thu gọn',
  Source: '',
  SpecialPrice: 'Giá đặc biệt',
  StartTime: 'Thời gian bắt đầu',
  StatBeginDate: 'Khoảng thời gian',
  StatBeginDateByDate: 'TG Nhập liệu',
  StatBeginDateByPort: 'TG Hiệu lực',
  StatEndDate: 'Đến',
  StatSucceed: 'Thao tác thành công!',
  State: 'TT Giá cước',
  Statistics: 'Thống kê',
  SubContractNo: 'MÃ',
  SubmittedBy: 'Người gửi',
  SubmittedDate: 'Thời gian gửi',
  Subscribe: 'Đăng ký',
  SubscribeCondition: 'Điều kiện đăng ký',
  SubscribeFromTenant: 'Tenant của người đăng ký',
  SubscribePOD: 'Địa điểm dỡ hàng',
  SubscribePOL: 'Địa điểm khởi hành',
  SubscribeType: 'Loại đăng ký',
  Subscriber: 'Người đăng ký',
  Sum: 'Tổng chi phí',
  SumAbnormal: 'Tổng chi phí vận chuyển có bất thường;',
  Sun: 'Chủ nhật',
  Sunday: 'Chủ nhật',
  Surcharge: 'Phụ phí',
  SurchargeLoadFailed: 'Tải phụ phí thất bại!',
  Suspend: 'Ngừng bay',
  SuspendRate: 'Giá có nền màu xám đã ngừng bay!',
  SuspendSelection: 'Đặt giá đã chọn thành trạng thái {0}?',
  TSport: 'Cảng trung chuyển',
  TaskStart: 'Nhiệm vụ kiểm duyệt đã gửi đến hậu trường, vui lòng kiểm tra dữ liệu trong tab đã xuất bản sau!',
  Template: 'Tải mẫu',
  TenantPrompt: 'Vui lòng nhập Tenant',
  Three_BE_One: 'Giá vận chuyển cấp 3 không được nhỏ hơn cấp 1!',
  Three_BE_Two: 'Giá vận chuyển cấp 3 không được nhỏ hơn cấp 2!',
  Three_B_One: 'Giá vận chuyển cấp 3 phải lớn hơn cấp 1!',
  Thu: 'Thứ năm',
  Thursday: 'Thứ năm',
  Times: 'Lần',
  Tips: 'Nhắc nhở',
  TotalAmount: 'Số bản ghi',
  TradeLane: 'Tuyến đường',
  TransferPort: 'Cảng trung chuyển',
  TransportMode: 'Phương thức vận chuyển',
  Tue: 'Thứ ba',
  Tuesday: 'Thứ ba',
  Two_BE_One: 'Giá vận chuyển cấp 2 không được nhỏ hơn cấp 1!',
  Two_B_One: 'Giá vận chuyển cấp 2 phải lớn hơn cấp 1!',
  UnNo: 'Số UN',
  UnitPrice: 'Đơn giá',
  UploadFailed: 'Tải lên thất bại.',
  UploadSucceed: 'Tải lên thành công.',
  VALIDITY_ERROR: 'Chỉ cho phép nhập giá vận chuyển trong hai tháng tới; \n',
  VALIDITY_LESS: '{0} hàng,"{1}"Không thể nhỏ hơn"Valid fm";\n',
  VAT: 'Thuế suất',
  ValidAbnormal: 'Hiệu lực giá vận chuyển có bất thường;',
  Validation: 'Tính hiệu lực',
  ValidityCfgLoadError: 'Tải dữ liệu cấu hình xác minh hiệu lực giá vận chuyển thất bại!',
  VatIncluded: 'Bao gồm thuế',
  VatInvalid: 'Thuế suất giá bán không được nhỏ hơn thuế suất giá thành',
  Via: 'Cảng trung chuyển',
  View: 'Xem',
  Visible: 'Hiển thị',
  Volume: 'Thể tích',
  VolumeCost: 'Chi phí giá thể tích',
  VolumePrice: 'Giá thể tích',
  WYSIWYG: 'WYSIWYG (Nhìn thấy là có được)',
  WantApply: 'Tên bên yêu cầu giá cước',
  Warning: 'Cảnh báo',
  Wed: 'Thứ Tư',
  Wednesday: 'Thứ Tư',
  Week: 'Tuần này',
  Weight: 'Trọng lượng (KG)',
  WeightCost: 'Chi phí giá trọng lượng',
  WeightLimitInfo: 'Thông tin hạn chế trọng lượng',
  WeightLimitLoadFailed: 'Tải thông tin hạn chế trọng lượng thất bại!',
  WeightPrice: 'Giá trọng lượng',
  WeightRule: 'Quy định hạn chế trọng lượng',
  Weight_LCL: 'Trọng lượng',
  Wrong: 'Không chính xác!',
  WrongInput: 'Nhập sai!',
  EtaMustBeLaterThanOrEqualToEtd: 'ETA phải muộn hơn hoặc bằng ETD',
  Yes: 'Có',
  YesLabel: 'Xem',
  amsEns: 'AMS/ENS (Khai báo hải quan tự động)',
  inviteTime: 'Ngày mời',
  jobTypeExport: 'Xuất khẩu',
  jobTypeImport: 'Nhập khẩu',
  overloadRemarks: 'Giải thích quá tải',
  quantity: 'Số kiện',
  resetDataGrid: 'Đặt lại bảng',
  selectedCount: 'Hiện đã chọn {0} bản ghi.',
  AcceptTenant2: 'Bên đăng ký',
  AcceptUser2: 'Người vận hành bên đăng ký',
  AcceptTime2: 'Ngày hiệu lực chia sẻ giá cước',
  InviteTenant2: 'Bên chia sẻ',
  InviteUser2: 'Người vận hành bên chia sẻ',
  inviteTime2: 'Ngày gửi lời mời/đơn yêu cầu',
  customSpecs: 'Quy cách tùy chỉnh',
  reject: 'Từ chối',
  fclRateSearch: 'Truy vấn giá cước container đầy',
  onlyViewAndEditCostAreAllow: 'Chỉ cho phép xem và chỉnh sửa giá cước chi phí',
  SubscribePOLType: 'Loại địa điểm xuất phát',
  DestinationType: 'Loại địa điểm đích',
  Destination: 'Điểm đến',
  OtherCharge: 'Chi phí khác',
  priceNoPrompt: 'Vui lòng nhập số giá cước hoặc 7 chữ số cuối',
  polOrPodOrRegionOneMustBeEntered: 'Phải nhập ít nhất một trong các mục: cảng đi, cảng đến hoặc tuyến đường',
  costAndSumInvalidSave: 'Giá bán nhỏ hơn chi phí n Xác nhận bảo quản',
  pleaseChooseOtherOfficeData: 'Không chọn dữ liệu hoặc chọn dữ liệu chi nhánh khác.',
  noSelectedPrice: 'Chưa chọn giá cước.',
  BelongingCity: 'Thành phố hiện tại',
  UpdateQuotationValidity: 'Có cập nhật ngày hết hạn báo giá theo thời hạn hiệu lực của giá cước không?',
  CheckQuotationDeleteTip: 'Báo giá đã tạo đơn hàng không được phép xóa!',
  PlsSelectAirOF: 'Vui lòng chọn một thông tin giá cước làm cước phí vận chuyển hàng không.',
  NotMatchChargeItem: 'Không tìm thấy tên phí phù hợp ({0}), vui lòng bảo trì mã nền tảng 【{1}】 trong mục phí!',
  AirFreight: 'Cước hàng không',
  WarExpenses: 'Phí chiến tranh',
  FuelSurcharge: 'Phụ phí nhiên liệu',
  WarehousingFee: 'Phí nhập kho',
  SeaFreight: 'Cước biển',
  QuotationWeightAndCubageLessZero: 'Trọng lượng và thể tích báo giá không được nhỏ hơn 0!',
  Name: 'Tên',
  MatchType: 'Phương thức khớp',
  PriceType: 'Loại giá cước',
  priceNature: 'Tính chất vận chuyển',
  TraditionalFreightRates: 'Giá cước offline',
  Traditional: 'Offline',
  ECommerce: 'Thương mại điện tử',
  SpotFreightRates: 'Giá cước TMĐT',
  ConfigureTheSurcharge: 'Cấu hình phụ phí',
  ConfigureTheSurchargeTips: 'Có thể cấu hình các phụ phí cần hiển thị trên danh sách',
  SpotContainerWeightTips: 'Trọng lượng container mặc định giá cước TMĐT: 18.000KG',
  TariffTableExportExcelTips: 'Do khối lượng dữ liệu, nên chọn thời hạn hiệu lực trước và không quá 3 tháng',
  PolCountry: 'Quốc gia cảng đi',
  PolRegion: 'Khu vực cảng đi',
  PodCountry: 'Quốc gia cảng đến',
  PriceProfile: 'Thông tin chiến lược',
  SharingProfile: 'Chia sẻ chiến lược',
  SelectProfile: 'Chọn CL',
  ViewProfile: 'Xem chiến lược',
  PodCity: 'Thành phố cảng đến',
  weightVolume: 'Tỷ trọng hàng hóa',
  DestinationAgent: 'Đại lý cảng đến',
  warehouse: 'Kho hàng',
  WarehouseName: 'Tên kho hàng',
  WarehouseAddress: 'Địa chỉ kho hàng',
  WarehouseMap: 'Bản đồ kho hàng',
  warehouseContact: 'Người liên hệ kho hàng',
  FlightInformationManagement: 'Quản lý thông tin chuyến bay',
  FlightNo: 'Số hiệu chuyến bay',
  ClosingTime: 'Thời gian chốt đơn',
  DepartureTime: 'Thời gian cất cánh',
  ArrivalTime: 'Thời gian đến',
  SizeLimit: 'Giới hạn kích thước',
  SingletonWeightLimit: 'Giới hạn trọng lượng đơn vị',
  ChemicalPkggReq: 'Yêu cầu đóng gói hóa chất',
  LithiumBatteryReq: 'Yêu cầu pin lithium',
  TimeWarning: 'Thời gian đến phải lớn hơn thời gian cất cánh',
  AirDay: 'Số ngày',
  flightNumber: 'Số chuyến bay không được để trống',
  emptyTime: 'Đây là giờ địa phương.',
  BatchImportQuotations: 'Nhập hàng loạt báo giá',
  XSuccessfulXFailed: 'Thành công 【{0}】 dòng, thất bại 【{1}】 dòng!',
  ErrorVolumeWeightRatio: 'Tỷ lệ thể tích/trọng lượng nhập sai!',
  AirPriceServiceItem: 'Nhập thất bại, dịch vụ cước vận chuyển hàng không chưa có dữ liệu nào, vui lòng bổ sung dữ liệu trước',
  HsCode: 'Mã HS'
}

